export const Bse2Badge = ({ bse2 }) => {
  if (!bse2 || !bse2.status || bse2.status === "NOT_CONFIGURED") return null;
  const ok = bse2.status === "SUBMITTED" || bse2.status === "CANCEL_SENT";
  const failed = bse2.status === "FAILED";
  const cls = ok
    ? "border-emerald-200 bg-emerald-50 text-emerald-700"
    : failed
      ? "border-rose-200 bg-rose-50 text-rose-700"
      : "border-amber-200 bg-amber-50 text-amber-700";
  const label = bse2.status === "SUBMITTED"
    ? `BSE ✓${bse2.bse_order_id ? ` #${bse2.bse_order_id}` : bse2.reg_no ? ` #${bse2.reg_no}` : ""}${bse2.live_status ? ` · ${bse2.live_status}` : ""}`
    : `BSE: ${String(bse2.status).replaceAll("_", " ")}`;
  return (
    <span className="inline-flex items-center gap-1">
      <span
        title={bse2.message || ""}
        data-testid="bse2-badge"
        className={`inline-flex items-center whitespace-nowrap rounded-full border px-2 py-0.5 text-[10px] font-semibold ${cls}`}
      >
        {label}
      </span>
      {bse2.auth_link && (
        <a
          href={bse2.auth_link}
          target="_blank"
          rel="noreferrer"
          data-testid="bse2-auth-link"
          className="whitespace-nowrap text-[10px] font-semibold text-[var(--cta)] underline"
        >
          Authenticate on BSE →
        </a>
      )}
    </span>
  );
};
